import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../../assets/css/Form.css';
import logo from '../../../assets/images/Logo.svg';
import { useForm } from '../../hooks/useForm';
import { ReqPost } from '../../../config/Requests';
import ValidateEmail from '../../../helper/emailValidator';
import { toast } from 'react-toastify';
// import { useToasts } from 'react-toast-notifications';

function ResetPassword() {
	const [values, handleChange] = useForm({ email: '' });
	let navigate = useNavigate();

	const handleSubmit = e => {
		e.preventDefault();
		if (!ValidateEmail(values.email)) {
			toast.error('Email is not valid.');

			return false;
		}
		ReqPost('invite-member', values)
			.then(res => {
				navigate(`/invite-success`);
			})
			.catch(err => {
				console.log(err.response);
			});
	};

	return (
		<div className='main-container form-bg-color'>
			<img src={logo} className='form-logo' alt='logo' />
			<div className='form-container'>
				<div className='form-label-header'>INVITE MEMBER</div>
				<span className='text-reset'>
					Enter email address to send invitation.
				</span>

				<form id='reset-password' className='form-container-inner'>
					<input
						className='form-input text-center'
						type='email'
						id='email'
						value={values.email}
						onChange={handleChange}
						name='email'
						placeholder='Email'
						required
					/>
					<button type='submit' className='btn-reset' onClick={handleSubmit}>
						SEND INVITATION
					</button>
				</form>
			</div>
			<span>
				<Link to='/' className='btn-back-vmn'>
					{' '}
					🡠 Back{' '}
				</Link>{' '}
			</span>
		</div>
	);
}

export default ResetPassword;
